module.exports = __webpack_public_path__ + "static/media/特製鹹豬肉.ee6d6e49.jpg";